var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};
import { css, jsx } from "@emotion/react";
import clsx from "clsx";
import { Field } from "formik";
import PropTypes from "prop-types";
import React from "react";
import FormFieldDescription from "./FormFieldDescription";
import FormFieldError from "./FormFieldError";
import FormFieldLabel from "./FormFieldLabel";
import FormFieldWrapper from "./FormFieldWrapper";
import { useIconContext } from "./IconProvider";
import * as defaultStyles from "./FormSelectField.module.css";
FormSelectField.propTypes = {
  className: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.string),
  styles: PropTypes.objectOf(PropTypes.string),
  icon: PropTypes.oneOfType([PropTypes.exact({
    name: PropTypes.string.isRequired
  }), PropTypes.exact({
    src: PropTypes.string.isRequired
  })])
};
export default function FormSelectField(_a) {
  var _b = _a,
    {
      className,
      options,
      styles = defaultStyles,
      icon = {
        name: "chevron-down"
      }
    } = _b,
    restProps = __objRest(_b, ["className", "options", "styles", "icon"]);
  const {
    getIconSrc
  } = useIconContext();
  return /* @__PURE__ */jsx(FormFieldWrapper, __spreadValues({
    className: clsx(styles.component, className),
    css: css({
      "--form-select-icon": "url(".concat(icon.src || getIconSrc(icon.name), ")")
    })
  }, restProps), _ref => {
    let {
      name,
      controlProps
    } = _ref;
    return /* @__PURE__ */jsx(React.Fragment, null, /* @__PURE__ */jsx(FormFieldLabel, {
      className: styles.label
    }), /* @__PURE__ */jsx(FormFieldDescription, {
      className: styles.description
    }), /* @__PURE__ */jsx(FormFieldError, {
      className: styles.error
    }), /* @__PURE__ */jsx("div", {
      className: styles.control
    }, /* @__PURE__ */jsx(Field, __spreadValues({
      as: "select",
      className: styles.select,
      name
    }, controlProps), /* @__PURE__ */jsx("option", {
      value: ""
    }, "V\xE4lj ett alternativ"), options ? options.map(option => {
      return /* @__PURE__ */jsx("option", {
        value: option,
        key: option
      }, option);
    }) : null)));
  });
}